var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":_vm.transitionName}},[_c('keep-alive',{attrs:{"include":_vm.keepAliveList}},[_c('router-view',{key:_vm.$route.fullPath,staticClass:"h5-page"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }